import { apiGet, apiPatch, apiPost, apiPut, apiDelete } from './api';
import { URL_SEANCE, URL_SEANCE_BY_ID, URL_SEANCE_BY_CODE_ACCES, 
         URL_START_SEANCE_BY_ID, URL_STOP_SEANCE_BY_ID,
         URL_KRACH, URL_KRACH_BY_ID, URL_STOP_KRACH_BY_ID, 
         URL_KRACH_BY_SEANCE, URL_KRACH_RUNNING_BY_SEANCE,
         URL_TOOGLE_NEED_PAYMENT_METHOD_SEANCE_BY_ID,
         URL_ANONYMOUS_SEANCE_BY_ID, URL_EXPORT_DATA_BY_SEANCE_ID,
         URL_TOTAL_PRICE_BY_SEANCE_ID, URL_NEWS_BY_SESSION_ID } from './urls';

export async function getAllSeances() {
  const response = await apiGet(URL_SEANCE);
  return response;
}
export async function createSeance(seance) {
    const response = await apiPost(URL_SEANCE, seance);
    return response;
}
export async function getSeanceById(id) {
  const response = await apiGet(URL_SEANCE_BY_ID(id));
  return response;
}
export async function getSeanceByCodeAcces(code_acces) {
  const response = await apiGet(URL_SEANCE_BY_CODE_ACCES(code_acces), false);
  return response;
}
export async function getAnonymousSeanceById(id) {
  const response = await apiGet(URL_ANONYMOUS_SEANCE_BY_ID(id), false);
  return response;
}
export async function updateSeance(seance) {
  const response = await apiPut(URL_SEANCE_BY_ID(seance.id), seance);
  return response;
}
export async function deleteSeance(seance) {
  const response = await apiDelete(URL_SEANCE_BY_ID(seance.id));
  return response;
}
export async function startSeance(seance) {
  const response = await apiPost(URL_START_SEANCE_BY_ID(seance.id))
  return response;
}
export async function stopSeance(seance) {
  const response = await apiPost(URL_STOP_SEANCE_BY_ID(seance.id))
  return response;
}
export async function toggleSeanceNeedPaymentMethod(seance) {
  const response = await apiPost(URL_TOOGLE_NEED_PAYMENT_METHOD_SEANCE_BY_ID(seance.id))
  return response;
}
export async function getKrachsBySeance(seance) {
  const response = await apiGet(URL_KRACH_BY_SEANCE(seance.id));
  return response;
}
export async function startKrach(seance) {
  const response = await apiPost(URL_KRACH, {"seance": seance.id});
  return response;
}
export async function stopKrach(krach) {
  const response = await apiPost(URL_STOP_KRACH_BY_ID(krach.id));
  return response;
}
export async function exportData(seanceId) {
  const response = await apiPost(URL_EXPORT_DATA_BY_SEANCE_ID(seanceId));
  return response;
}
export async function getTotalPriceBySeance(seanceId) {
  const response = await apiGet(URL_TOTAL_PRICE_BY_SEANCE_ID(seanceId))
  return response
}
export async function getNewsBySession(sessionId) {
  const response = await apiGet(URL_NEWS_BY_SESSION_ID(sessionId), false)
  return response
}